import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function getAllCustomerConfigList() {
  return axiosInstance.get(`customer/configs`);
}

//store list
export function getCustomerStoreList(data) {
  return axiosInstance.post(`customer/store-list`, formatRequest(data));
}

//store Details
export function getCustomerStoreDetailsList(data) {
  return axiosInstance.post(`customer/store-details`, formatRequest(data));
}

//category list
export function getCustomerCategoryList(data) {
  return axiosInstance.post(`customer/category-list`, formatRequest(data));
}

//product list
export function getCustomerProductList(data) {
  return axiosInstance.post(`customer/product-list`, formatRequest(data));
}

export function getCustomerProductFavList(data) {
  return axiosInstance.post(`customer/product-fav-list`, formatRequest(data));
}

//create order
export function createCustomerOrder(data) {
  return axiosInstance.post(`customer/order-create`, formatRequest(data));
}

//order list
export function getCustomerOrderList(data) {
  return axiosInstance.post(`customer/order-list`, formatRequest(data));
}

//order details
export function getCustomerOrderDetails(data) {
  return axiosInstance.post(`customer/order-details`, formatRequest(data));
}

//set store pin 
export function createCustomerStorePin(data) {
  return axiosInstance.post(`customer/set-store-pin`, formatRequest(data));
}

//update store pin
export function updateCustomerStorePin(data) {
  return axiosInstance.post(`customer/update-store-pin`, formatRequest(data));
}

//remove store pin
export function removeCustomerStorePin(data) {
  return axiosInstance.post(`customer/remove-store-pin`, formatRequest(data));
}

//dashboard details
export function getCustomerDashboardDetails(data) {
  return axiosInstance.post(`customer/dashboard`, formatRequest(data));
}

//pending payments by store
export function getPendingPaymentsByStore(data) {
  return axiosInstance.post(`customer/pending-payments-by-store`, formatRequest(data));
}


//admin side customer list
export function getCustomerAllList(data) {
  return axiosInstance.post(`customer/customer-all-list`, formatRequest(data));
}

